<template>
    <div id="productgrouppage">
        <spinner-text v-if="!product || !repairReasons">
            {{ trans('pages.productgroup.loading') }}
        </spinner-text>
        <template v-else>
            <actions-menu ref="actionsButton">
                <actions-menu-item
                    v-if="hasRight('productionmanagement')"
                    :v4="true"
                    :action="orderForProductgroupButtonClicked"
                    icon="arrow-left"
                    :label="trans('pages.productgroup.order_for_productgroup')" />
                <actions-menu-item
                    v-if="hasRight('administration')"
                    :action="remove"
                    :v4="true"
                    class="alert"
                    icon="exclamation-circle"
                    :label="trans('pages.productgroup.delete')" />
                <actions-menu-item
                    :v4="true"
                    :action="createService"
                    icon="pencil"
                    :label="trans('pages.productgroup.create_service')" />
                <actions-menu-item
                    :v4="true"
                    id="productgroupsaw"
                    :action="() => $router.push('/productsaw/' + productId)"
                    icon="list-ol"
                    :label="trans('pages.productgroup.saw_list')" />
                <actions-menu-item
                    :v4="true"
                    :action="productgroupProductionLabelClicked"
                    icon="tag"
                    :label="trans('pages.productgroup.print_production_label')" />
                <!-- Only VLR -->
                <actions-menu-item
                    v-if="product.producttype == 1"
                    :v4="true"
                    :action="productgroupSawLabelClicked"
                    icon="tag"
                    :label="trans('pages.productgroup.print_vlr_label')" />
                <actions-menu-item
                    :v4="true"
                    :action="
                        () => $router.push('/productgroupdetails/' + productId)
                    "
                    icon="wrench"
                    :label="trans('pages.productgroup.production_bon')" />
                <actions-menu-item
                    :v4="true"
                    :action="() => setProductstatusDone(productId, '', 1)"
                    icon="check-circle"
                    :label="trans('pages.productgroup.mark_completed')" />
                <actions-menu-item
                    v-if="hasRight('productionmanagement')"
                    :v4="true"
                    :action="productErrorClicked"
                    icon="exclamation-circle"
                    :label="trans('pages.productgroup.report_error')" />
                <actions-menu-item
                    :v4="true"
                    :action="
                        () => $router.push('/editproductgroup/' + productId)
                    "
                    icon="paint-brush"
                    :label="trans('pages.productgroup.change_color')" />
                <actions-menu-item
                    v-if="hasRight('productionmanagement')"
                    :v4="true"
                    :action="() => $router.push('/producthistory/' + productId)"
                    icon="history"
                    :label="trans('pages.productgroup.history')" />
            </actions-menu>

            <div class="productgrouppagedefaultfields">
                <p>
                    {{ trans('pages.productgroup.customer') }}:
                    <span>{{ product.customername }}</span>
                </p>
                <p>
                    {{ trans('pages.productgroup.paint_lists') }}:
                    <ul>
                        <li
                            v-for="paintlistId in paintlistIds"
                            :key="paintlistId"
                        >
                            <span
                                @click="
                                    $router.push(
                                        '/optimizedpaintlistview/' + paintlistId
                                    )
                                "
                                class="link"
                            >
                                {{ paintlistId }}
                            </span>
                        </li>
                    </ul>
                </p>
                <p>
                    {{ trans('pages.productgroup.reference') }}:
                    <span>{{ product.reference }}</span>
                </p>
                <p>
                    {{ trans('pages.productgroup.name') }}:
                    <span>{{ product.name }}</span>
                </p>
                <p>
                    {{ trans('pages.productgroup.status') }}:
                    <span>{{ product.currentStatus }}</span>
                </p>
                <p>
                    {{ trans('pages.productgroup.ride_nr') }}:
                    <span>{{ product.deliveryDateKey }}</span>
                </p>
            </div>

            <h2>{{ trans('pages.productgroup.products_in_group') }}</h2>
            <div v-if="product && product.products">
                <div
                    class="productgroupelement"
                    v-for="subproduct in product.products"
                    :key="subproduct.productNr">
                    {{ subproduct.producttype }} {{ subproduct.productNr }} -
                    {{ subproduct.name }} - {{ subproduct.status }}
                </div>
            </div>

            <popover-repair-reason-form
                v-if="repairReasons"
                :product-id="productId"
                :header-text="trans('pages.productgroup.create_service')"
                ref="popoverMakeService"
                :action="makeServiceAction"
                :repair-reasons="repairReasons" />
            <popover-repair-reason-form
                v-if="repairReasons"
                :product-id="productId"
                :header-text="trans('pages.productgroup.report_error')"
                ref="popoverProductError"
                :action="makeErrorAction"
                :repair-reasons="repairReasons" />
        </template>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import PopoverRepairReasonForm from '../components/products/PopoverRepairReasonForm';
import RepairReasonActionsMixin from '../mixins/repair-reason-actions';
import SpinnerText from '../components/loader/SpinnerText';
import productApi from '../api/product';
import repairApi from '../api/repair';
import exportApi from '../api/export';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { mapGetters } from 'vuex';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import localization from '../mixins/localization';

export default {
    data() {
        return {
            productId: null,
            product: null,
            repairReasons: null,
        };
    },
    mixins: [RepairReasonActionsMixin, NavigationFunctionsMixin, localization],
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
                ]();
        },
        paintlistIds () {
            if (!this.product || !this.product.paintlistId) {
                return [];
            }
            return this.product.paintlistId.split(',').map((id) => id.trim());
        },
    },
    methods: {
        createService() {
            this.$refs.popoverMakeService.open(this.$refs.actionsButton.$el);
        },
        productErrorClicked() {
            this.$refs.popoverProductError.open(this.$refs.actionsButton.$el);
        },
        productgroupSawLabelClicked() {
            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printWindowLabel(this.productId, this.selectedPrinterPostParameter)
                    .then(() => { showInfoMessage(this.trans('pages.productgroup.labels_printed')); }),
                Config.url + '/export/exportWindowLabel/?productId=' + this.productId
            );
        },
        productgroupProductionLabelClicked() {
            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printProductionLabel(this.productId, this.selectedPrinterPostParameter)
                    .then(() => { showInfoMessage(this.trans('pages.productgroup.labels_printed')); }),
                Config.url + '/export/exportProductionLabel/?productId=' + this.productId
            );
        },
        remove() {
            showConfirmDialog({
                title: this.trans('pages.productgroup.delete_confirm_title'),
                content: this.trans('pages.productgroup.delete_confirm_message'),
                confirm: () => {
                    productApi
                        .remove(this.productId)
                        .then(() => {
                            this.$router.push('/menu');
                        })
                        .catch(() => {
                            showErrorMessage(
                                this.trans('pages.productgroup.delete_error')
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: this.trans('pages.productgroup.delete_confirm_yes'),
                cancelButton: this.trans('pages.productgroup.delete_confirm_no'),
            });
        },
        orderForProductgroupButtonClicked() {
            productApi.fetchOrder(this.productId).then((response) => {
                this.$router.push(
                    '/editproduct/?orderId=' +
                    response.data.data.orderId +
                    '&productId=' +
                    this.productId
                );
            });
        },
    },
    components: {
        SpinnerText,
        PopoverRepairReasonForm,
        ActionsMenu,
        ActionsMenuItem,
    },
    mounted() {
        this.productId = this.$route.params.id;

        productApi.fetchProductGroup(this.productId).then((response) => {
            this.product = response.data.data;
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.productgroup.title', { productId: this.productId }),
                { root: true }
            );
        });

        repairApi.list().then((response) => {
            this.repairReasons = response.data.data;
        });
    },
};
</script>
